export enum UserRole {
  ADMIN = 'admin',
  CURATORS_LEAD = 'curators_lead',
  CURATOR = 'curator',
}

export interface RoutePermission {
  roles?: UserRole[]
}

export interface NavigationItem {
  name: string
  path: string
  icon?: string
  children?: NavigationItem[]
  roles?: UserRole[]
}

export const rolesLabels = {
  [UserRole.ADMIN]: 'Администратор',
  [UserRole.CURATORS_LEAD]: 'Тимлид кураторов',
  [UserRole.CURATOR]: 'Куратор',
}
